class Form {
  stateClasses = {
    error: "form-group--error",
  };
  constructor($el) {
    this.$el = $el;
    this.$form = $el.find('[data-form="form"]');
    this.$content = $el.find('[data-form="content"]');
    this.$success = $el.find('[data-form="success"]');
    this.$inputs = $el.find('[data-form="input"]');
    this.$submit = $el.find('[data-form="submit"]');
    this.$inputGroup = $el.find('[data-form="group"]');
    this.safari = navigator.userAgent.indexOf("Safari") > -1;

    this.$form.on("submit", this.submitHandler);
    // this.init();
  }

  submitHandler = (e) => {
    e.preventDefault();

    const form = e.target;

    const data = new FormData(form);
    let request = new XMLHttpRequest();

    if (this.safari) {
      for (var i = 0; i < form.elements.length; i++) {
        if (form.elements[i].type == "file") {
          if (form.elements[i].value == "") {
            var elem = form.elements[i];
            data.delete(elem.name);
          }
        }
      }
    }

    const method = form.getAttribute("method");
    const action = form.getAttribute("action");

    request.open(method, action ? action : window.location.href, true);
    request.setRequestHeader("Cache-Control", "no-cache");
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.setRequestHeader("HTTP_X_REQUESTED_WITH", "XMLHttpRequest");
    request.setRequestHeader("Accept", "application/json");

    this.lockSubmit();

    request.onload = () => {
      this.removeErrors();
      if (request.status === 200) {
        const response = JSON.parse(request.response);

        if (response.success) {
          this.handleSuccess();
        } else if (response.errors) {
          this.showErrors(response.errors);
        }
      } else {
        console.error(request);
      }
      this.unlockSubmit();
    };

    request.send(data);
  };

  lockSubmit = () => {
    this.$submit.prop("disabled", true);
  };

  unlockSubmit = () => {
    this.$submit.prop("disabled", false);
  };

  handleSuccess = () => {
    this.$content.remove();

    this.$success.removeClass("d-none");
  };

  showErrors = (errors) => {
    for (var key in errors) {
      const $input = this.$el.find(`[name="${key}"]`);
      const $inputGroup = $input.closest('[data-form="group"]');
      $inputGroup.addClass(this.stateClasses.error);
    }
  };

  removeErrors = () => {
    this.$inputGroup.removeClass(this.stateClasses.error);
  };

  init = () => {
    // this.$submit.on("click", this.validateForm);
    // this.$inputs.on("change", this.validateInput);
  };

  // get all invalid inputs and add error class to the form-group
  // validateForm = (e) => {
  //   if (!this.isValid()) {
  //     e.preventDefault();

  //     this.$inputs.each((i, input) => {
  //       const $input = $(input);
  //       const $formGroup = $input.closest('[data-form="group"]');

  //       const isValid = input.checkValidity();
  //       if (!isValid) {
  //         $formGroup.addClass(this.stateClasses.error);
  //       } else {
  //         $formGroup.removeClass(this.stateClasses.error);
  //       }
  //     });
  //   }
  // };

  // // check if form is valid
  // isValid = () => {
  //   let isValid = true;
  //   this.$inputs.each((i, input) => {
  //     isValid = input.checkValidity();
  //     console.log("input, isValid", input, isValid);
  //     if (!isValid) {
  //       return false;
  //     }
  //   });
  //   return isValid;
  // };

  // // checkvalidity of input and remove error class from form-group
  // validateInput = (e) => {
  //   const input = e.target;
  //   const $input = $(input);
  //   const $formGroup = $input.closest('[data-form="group"]');

  //   const isValid = input.checkValidity();
  //   if (!isValid) {
  //     $formGroup.addClass(this.stateClasses.error);
  //   } else {
  //     $formGroup.removeClass(this.stateClasses.error);
  //   }
  // };
}

export default Form;
